import type { FormState, RegisterReference } from '@/shared/types/users.types';
import type { ColorHelpers } from '@/utils/colorHelpers';
import { SearchableSelect } from '@/backoffice/components/ui/SearchableSelect';

interface Props {
    form: FormState;
    set: <K extends keyof FormState>(k: K, v: FormState[K]) => void;
    reference: RegisterReference;
    c: ColorHelpers;
}

export function StepIdentity({ form, set, reference, c }: Props) {
    const zoneOptions = reference.zones.map(zone => ({
        value: String(zone.id),
        label: zone.name,
    }));

    return (
        <div className="space-y-5">
            <h2 className="text-xl font-semibold text-gray-900">Zone principale</h2>
            <p className="text-sm text-gray-500">
                Sélectionnez la zone où vous êtes basé(e). Cette information est requise.
            </p>

            <SearchableSelect
                label="Zone *"
                value={form.zoneId}
                onChange={v => set('zoneId', v)}
                options={zoneOptions}
                placeholder="Rechercher une zone…"
                className="w-full"
            />
        </div>
    );
}
